import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { changePassword } from '../../services/authService'
import Card from '../card/Card'
import './ChangePassword.scss'

const initialState=
{
  oldPassword:"",
  password:"",
  password2:''
}

const ChangePassword = () => {
  const[formData,setformData]=useState(initialState)
  const {oldPassword,password,password2}=formData
  const naviage=useNavigate()

  const handleInputChange=(e)=>
  {
    const {name,value}=e.target;

    // get the initial state, then set the [name]'s value to value
    setformData({...formData,[name]:value}); 
  }

  const changePass=async(e)=>
  {
    e.preventDefault()

    if(password!=password2)
    {
      return toast.error("New password do not match!")
    }

    const formdata=
    {
      oldPassword,
      password
    }

    const data=await changePassword(formdata)

    toast.success(data)

    naviage('/profile')

  }

  return (
    <div className='change-password'>
        <Card className='password-card'>
          <h3>
            Change Password
          </h3>

          <form onSubmit={changePass} className='--form-control'>
            <input type='password' placeholder='Old Password' required name="oldPassword" value={oldPassword} onChange={handleInputChange}/>
            <input type='password' placeholder='New Password' required name="password" value={password} onChange={handleInputChange}/>
            <input type='password' placeholder='Confirm New Password' required name="password2" value={password2} onChange={handleInputChange}/>

            <button type='submit' className='--btn --btn-primary'>
              Change Password
            </button>
          </form>
        </Card>
    </div>
  )
}

export default ChangePassword
